import React from 'react';
import { ModalBackground, ModalCenterButtonFooter, ModalContent, ModalLayout, ModalTitle } from './ModalForms';
import styled from 'styled-components';
import Noti_Warning from 'assets/Icons/ToastIcons/Noti_Warning';
import { IModalProps, NoShowModalProps } from 'models/Common/modalTypes';
import Profile from 'components/DesignSystem/InfoCard/Profile';
import { TextareaAutosize } from '@mui/material';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { font, palette } from 'styles/Global/globalStyles';
import { DCKTextArea } from 'styles/Global/TextAreaStyles';
import { CloseButtonWrapper } from 'styles/Modal/modalStyle';
import CloseDialogue from 'assets/Icons/DeleteIcon/CloseDialogue';
import { MixConfirmed, NotConfirmed } from 'components/DesignSystem/ConfirmButton/ConfirmedButton';
import BasicButton from 'components/Buttons/BasicButton';

const ProfileDetailInfoWithInput = ({
    cancelButton,
    confirmButton,
    title,
    firstContent,
    secondContent,
    firstButton,
    secondButton,
    name,
    subText,
    firstLabel,
    firstLabelText,
    secondLabel,
    secondLabelText,
    thirdLabel,
    thirdLabelText,
    gender,
    setCounselReason,
    counselReason,
    checkedCall,
    setCheckedCall,
}: NoShowModalProps) => {
    return (
        <ModalBackground>
            <ModalLayout $width='520px' $gap='12px'>
                <ModalTitleAndContentContainer>
                    <TitleAndIconWrapper>
                        <Noti_Warning />
                        <ModalTitle>{title}</ModalTitle>
                    </TitleAndIconWrapper>
                    <ContentsWrapper>
                        <ModalContent>{firstContent}</ModalContent>
                        <ModalContent>{secondContent}</ModalContent>
                    </ContentsWrapper>
                </ModalTitleAndContentContainer>
                <Profile
                    name={name}
                    subText={subText}
                    firstLabel={firstLabel}
                    firstLabelText={firstLabelText}
                    secondLabel={secondLabel}
                    secondLabelText={secondLabelText}
                    thirdLabel={thirdLabel}
                    thirdLabelText={thirdLabelText}
                    gender={gender}
                />
                <DCKTextArea minRows={3} placeholder='노쇼 관련 내용을 작성해주세요. (선택)' onChange={(e) => setCounselReason(e.target.value)} value={counselReason} />
                <MixConfirmed label='2번의 전화와 5분 후 재시도 완료' checked={checkedCall} setChecked={setCheckedCall} />
                <ModalCenterButtonFooter>
                    <BasicButton $width='160px' $height='48px' $type='fillLightGray' onClick={cancelButton}>
                        {firstButton}
                    </BasicButton>
                    <BasicButton $width='160px' $height='48px' $type='warning' onClick={confirmButton} disabled={!checkedCall}>
                        {secondButton}
                    </BasicButton>
                </ModalCenterButtonFooter>
                <CloseButtonWrapper onClick={cancelButton}>
                    <CloseDialogue />
                </CloseButtonWrapper>
            </ModalLayout>
        </ModalBackground>
    );
};

export default ProfileDetailInfoWithInput;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 12px;
`;

const TitleAndIconWrapper = styled.div`
    display: flex;
    gap: 8px;
`;

const ContentsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 48px;
    line-height: 22px;
`;
